import React, { useState } from 'react';
import config from './config';

const AdminPage = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [csvFile, setCsvFile] = useState(null);
  const [csvLoading, setCsvLoading] = useState(false);
  const [csvSource, setCsvSource] = useState('csv-import');
  const [useMapbox, setUseMapbox] = useState(true);
  const [lastResponse, setLastResponse] = useState(null);
  const [lastError, setLastError] = useState(null);
  const [showDebug, setShowDebug] = useState(true);

  const handleUpdate = async () => {
    setLoading(true);
    setResult(null);
    try {
      // Call Strapi endpoint to execute the fetch logic
      const response = await fetch(`${config.API_BASE}/api/locations/sync`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      const data = await response.json();
      setLastResponse({ status: response.status, ok: response.ok, body: data });
      setLastError(null);
      
      if (response.ok) {
        setResult(`Success: Created ${data.created} / Updated ${data.updated}`);
        alert('Location update triggered successfully!');
      } else {
        setResult(`Error: ${data.error?.message || 'Unknown error'}`);
        alert('Failed to sync locations.');
      }
    } catch (error) {
      console.error('Error triggering update:', error);
      setResult(`Connection Error: ${error.message}`);
      setLastError(error?.message || String(error));
      setLastResponse(null);
      alert('Error triggering update.');
    } finally {
      setLoading(false);
    }
  };

  const handleImportCsv = async () => {
    if (!csvFile) return;
    setCsvLoading(true);
    setResult(null);

    const formData = new FormData();
    formData.append('file', csvFile);
    formData.append('source', csvSource);
    formData.append('useMapbox', String(useMapbox));

    try {
      const response = await fetch(`${config.API_BASE}/api/locations/import-csv`, {
        method: 'POST',
        body: formData
      });

      const data = await response.json();
      console.log('[handleImportCsv] API 回傳:', data);
      setLastResponse({ status: response.status, ok: response.ok, body: data });
      setLastError(null);
      if (response.ok) {
        setResult(`CSV匯入成功: 新增 ${data.created} / 更新 ${data.updated} / 略過 ${data.skipped ?? 0}`);
        alert('CSV匯入完成！');
      } else {
        setResult(`CSV匯入失敗: ${data.error?.message || 'Unknown error'}`);
        alert('CSV匯入失敗');
      }
    } catch (error) {
      console.error('[handleImportCsv] 例外:', error);
      setResult(`CSV匯入連線錯誤: ${error.message}`);
      setLastError(error?.message || String(error));
      setLastResponse(null);
      alert('CSV匯入連線錯誤');
    } finally {
      setCsvLoading(false);
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <h1>Admin Page</h1>
      <p>This page handles administrative tasks, such as triggering data synchronization.</p>
      <button 
        onClick={handleUpdate} 
        disabled={loading}
        style={{ padding: '10px', cursor: 'pointer' }}
      >
        {loading ? 'Syncing...' : 'Fetch & Sync Daily Locations'}
      </button>
      <div style={{ margin: '30px 0 0 0', padding: '18px', border: '1px solid #eee', borderRadius: 8, background: '#fafbfc' }}>
        <h3>CSV 匯入/更新 Location</h3>
        <input
          type="file"
          accept=".csv,text/csv"
          onChange={e => setCsvFile(e.target.files?.[0] || null)}
          style={{ display: 'block', marginBottom: '12px' }}
        />
        <input
          type="text"
          value={csvSource}
          onChange={e => setCsvSource(e.target.value)}
          placeholder="資料來源代碼（source）"
          style={{ width: '320px', padding: '8px', marginRight: '10px', borderRadius: 4, border: '1px solid #ccc' }}
        />
        <label style={{ marginLeft: 10, marginRight: 10 }}>
          <input
            type="checkbox"
            checked={useMapbox}
            onChange={e => setUseMapbox(e.target.checked)}
            style={{ marginRight: 4 }}
          />
          缺少經緯度時使用 Mapbox Geocoding
        </label>
        <button onClick={handleImportCsv} disabled={csvLoading || !csvFile} style={{ padding: '8px 16px', cursor: 'pointer' }}>
          {csvLoading ? '匯入中...' : '上傳 CSV 匯入/更新'}
        </button>
      </div>
      {result && <p style={{ marginTop: '20px', fontWeight: 'bold' }}>{result}</p>}

      <div style={{ marginTop: 20 }}>
        <label style={{ marginRight: 10 }}>
          <input type="checkbox" checked={showDebug} onChange={e => setShowDebug(e.target.checked)} /> Show Debug Panel
        </label>
        <button onClick={() => { setLastResponse(null); setLastError(null); setResult(null); }} style={{ marginLeft: 10 }}>Clear Debug</button>
      </div>

      {showDebug && (lastResponse || lastError) && (
        <div style={{ marginTop: 12, padding: 12, border: '1px dashed #ccc', borderRadius: 6, background: '#fff' }}>
          <h4>Debug</h4>
          {lastResponse && (
            <div style={{ marginBottom: 8 }}>
              <div><strong>HTTP Status:</strong> {lastResponse.status} {lastResponse.ok ? '(OK)' : ''}</div>
              <div style={{ marginTop: 6 }}><strong>Body:</strong></div>
              <pre style={{ maxHeight: 300, overflow: 'auto', background: '#f6f8fa', padding: 8 }}>{JSON.stringify(lastResponse.body, null, 2)}</pre>
            </div>
          )}
          {lastError && (
            <div style={{ color: 'crimson' }}>
              <strong>Error:</strong>
              <pre style={{ background: '#fff4f4', padding: 8 }}>{String(lastError)}</pre>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AdminPage;
